﻿import Highcharts from 'highcharts';
import { alertSuccess, alertWarning } from './dialogs';
import Encoder from 'htmlencode';

/**
 * 
* Decimal adjustment of a number.
*
* @param {String}  type  The type of adjustment.
* @param {Number}  value The number.
* @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
* @returns {Number} The adjusted value.
*/
function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
        return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
        return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
}

function shadeColor(color, percent) {
    var R = parseInt(color.substring(1, 3), 16);
    var G = parseInt(color.substring(3, 5), 16);
    var B = parseInt(color.substring(5, 7), 16);

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R < 255) ? R : 255;
    G = (G < 255) ? G : 255;
    B = (B < 255) ? B : 255;

    var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
    var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
    var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

    return "#" + RR + GG + BB;
}

export function GetUriLastPart(uri) {
    var parts = uri.split('/');
    var lastPart = parts.pop();
    while (lastPart == '' && parts.length > 0) {
        lastPart = parts.pop();
    }

    return lastPart;
}

/* PS! Do we need to fix textarea so that can handle lineshifts, colon, comma's etc.. ?     ?   ??  ?            ??*/
export function submitForm(form, callback) {
    var url = form.attr('action');
    // clone form to prevent visual changes
    var tempForm = form.clone();
    var selects = form.find("select");
    var textareas = form.find("textarea");
    tempForm.find("textarea").remove();
    $(textareas).each(function (i) {
        var textarea = $(this);
        var hiddenInput = $("<input type='hidden' id='" + textarea.attr("id") + "' name='" + textarea.attr("name") + "' value='" + Encoder.htmlEncode(textarea.val()) + "' />");
        tempForm.append(hiddenInput);
    });
    $(selects).each(function (i) {
        var select = this;
        tempForm.find("select").eq(i).val($(select).val());
    });
    tempForm.find(".text-percent, .text-number").each(function () {
        var floatval = parseFloat($(this).val().replace(/[ ,]/g, ''));
        if (isNaN(floatval)) floatval = 0;
        $(this).val(floatval);
    });

    var serializedData = tempForm.serialize();

    $.ajax({
        url: url,
        method: "POST",
        data: serializedData,
        statusCode: {
            200: function (data, status, response) {
                callback(data);
                alertSuccess("Saved successfully!");
            },
            400: function (data, status, error) {
                var html = $.parseHTML(data.responseText);
                $(html).find(".input-validation-error").closest(".form-group").addClass("has-error");
                callback(html);
                alertWarning("Please correct your input");
            },

            // input, for derivatives
            456: function (data, status, error) {
                var html = $.parseHTML(data.responseText);
                $(html).find(".input-validation-error").closest(".form-group").addClass("has-error");
                callback(html);
                alertWarning("You have reached the maximum number for this subscription");
            },

            500: function (data, status, error) {
                callback(data.responseText);
                alertError("Save error!");
            }
        }
    });
}

export function submitPopupForm(form, callback) {
    var url = form.prop('action');
    // clone form to prevent visual changes
    var tempForm = form.clone();
    var selects = form.find("select");
    var textareas = form.find("textarea");
    tempForm.find("textarea").remove();
    $(textareas).each(function (i) {
        var textarea = $(this);

        var hiddenInput = $("<input type='hidden' id='" + textarea.attr("id") + "' name='" + textarea.attr("name") + "' value='" + Encoder.htmlEncode(textarea.attr("value")) + "' />");
        tempForm.append(hiddenInput);
    });
    $(selects).each(function (i) {
        var select = this;
        tempForm.find("select").eq(i).val($(select).val());
    });
    tempForm.find(".text-percent, .text-number").each(function () {
        var floatval = parseFloat($(this).val());
        if (isNaN(floatval)) floatval = 0;
        $(this).val(floatval);
    });

    var serializedData = tempForm.serialize();

    $.ajax({
        url: url,
        method: "POST",
        data: serializedData,
        statusCode: {
            200: function (data, status, response) {
                callback(data);
                var success = $("<label class='text-success' style='margin-right: 15px; display: none;'>Saved</label>");
                $(".modal-footer").prepend(success);
                success.fadeIn(300, function () {
                    setTimeout(function () { success.fadeOut(300); }, 2000);
                });
            },
            400: function (data, status, error) {
                var html = $.parseHTML(data.responseText);
                $(html).find(".input-validation-error").closest(".form-group").addClass("has-error");
                callback(html);
                var warning = $("<label class='text-warning' style='margin-right: 15px; display: none;'>Please check your input</label>");
                $(".modal-footer").prepend(warning);
                warning.fadeIn(300, function () {
                    setTimeout(function () { warning.fadeOut(300); }, 2000);
                });
            },

            500: function (data, status, error) {
                callback(data.responseText);
                var error = $("<label class='text-danger' style='margin-right: 15px; display: none;'>Save error</label>");
                $(".modal-footer").prepend(error);
                error.fadeIn(300, function () {
                    setTimeout(function () { error.fadeOut(300); }, 2000);
                });
            }
        }
    });
}

export function numberFormat(number, decimals, interval, useSymbols) {
    var negative = false;

    // Default values
    if (decimals == null) decimals = 2;
    if (useSymbols == null) useSymbols = true;

    if (number < 0) {
        negative = true;
        number = -number;
    }

    // First find number of decimals, if interval is provided
    if (interval != null && interval > 0) {
        var computedDecimals = -(Math.floor(Math.log(interval) / Math.LN10) - 1);
        decimals = Math.max(decimals, computedDecimals);
    }

    // Adjust for cases of 1000.100 (should be 1000.1)
    var rest = number - Math.floor(number);
    while (decimals > 0) {
        if (parseFloat(number.toFixed(decimals)) !== parseFloat(number.toFixed(decimals - 1))) {
            break
        }
        decimals--;
    }

    if (useSymbols) {
        var numericSymbols = ['k', 'M', 'G', 'T', 'P', 'E'];

        var power = Math.floor(Math.log(number) / Math.LN10);
        var symbol = Math.floor(power / 3) - 1;

        if (symbol >= 0 && symbol < numericSymbols.length) {
            return (negative ? '-' : '') + Highcharts.numberFormat(number / Math.pow(10, (symbol + 1) * 3), decimals) + numericSymbols[symbol];
        }
    }

    return (negative ? '-' : '') + Highcharts.numberFormat(number, decimals);
}

export function lightenDarkenColor(col, amt) {
    var usePound = false;
    if (col[0] == "#") {
        col = col.slice(1);
        usePound = true;
    }
    var num = parseInt(col, 16);
    var r = (num >> 16) + amt;
    if (r > 255) {
        r = 255;
    } else if (r < 0) {
        r = 0;
    }
    var b = ((num >> 8) & 0x00FF) + amt;
    if (b > 255) {
        b = 255;
    } else if (b < 0) {
        b = 0;
    }
    var g = (num & 0x0000FF) + amt;
    if (g > 255) {
        g = 255;
    } else if (g < 0) {
        g = 0;
    }
    return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
}

export function CalcPortfolioPrice() {
    var Tall1 = $("#solution-portfolio-portfolios").val();
    var Tall2 = $("#solution-portfolio-licenses").val();
    $.post(Router.action("Home", "CalculatePricePortfolio"), { Portfolios: Tall1, Licenses: Tall2 }, function (data) {
        $("#solution-portfolio-price-monthly").html(data.JSonReturnString1);        // Format to thousand
        $("#solution-portfolio-price-yearly").html(data.JSonReturnString2);         // Format to thousand
    });
}

export function CalcCorporatePrice() {
    var Tall1 = $("#Corp_nCompanies").val();
    var Tall2 = $("#Corp_nEntities").val();
    var Tall3 = $("#Corp_nFX").val();
    var Tall4 = 1;                          // Licenses?

    if (Tall1 == null) {
        Tall1 = 10;
    }
    if (Tall2 == null) {
        Tall2 = 1;
    }
    if (Tall3 == null) {
        Tall3 = 1;
    }
    if (Tall4 == null) {
        Tall4 = 1;
    }

    $.post(Router.action("Home", "CalculatePriceCorporate"), { Corporates: Tall1, Entities: Tall2, Currencies: Tall3, Licenses: Tall4 }, function (data) {
        $("#CorpProfessionalPrice").html(data.JSonReturnString1);
        $("#CorpProfessionalPriceWarning").html(data.JSonReturnString2);
    });
}

export function CalcCurrencyPrice() {
    var Tall1 = $("#solution-currency-portfolios").val();
    var Tall2 = $("#solution-currency-licenses").val();

    $.post(Router.action("Home", "CalculatePriceCurrency"), { Portfolios: Tall1, Licenses: Tall2 }, function (data) {
        $("#solution-currency-price-monthly").html(data.JSonReturnString1);        // Format to thousand
        $("#solution-currency-price-yearly").html(data.JSonReturnString2);         // Format to thousand
    });
}

export function selectDateRange(from, to) {
    $(from).datepicker({
        defaultDate: "+1w",
        onClose: function (selectedDate) {
            $(to).datepicker("option", "minDate", selectedDate);
        }
    });
    $(to).datepicker({
        defaultDate: "+1w",
        onClose: function (selectedDate) {
            $(from).datepicker("option", "maxDate", selectedDate);
        }
    });
}
